import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase';

const recomputeAllocationsCallable = httpsCallable(functions, 'recomputeFundInvestorPeriodAllocations');

/**
 * Recompute interest allocations for a lender/month (lender only).
 * @param {{ periodKey?: string, year?: number, month?: number }} params
 * @returns {Promise<object>}
 */
export async function recomputeFundInvestorPeriodAllocations(params) {
  const res = await recomputeAllocationsCallable(params || {});
  return res?.data;
}

